// Ensure a stable CSS hook for progressive enhancement
document.documentElement.classList.add("js");

/* ======================================================
   ULTRA HERO — STABLE + OPTIMIZED (COPY/PASTE)
   - No duplicate DOMContentLoaded
   - Safe province engine intercept
   - Title parse (series + name) once
   - Province → variant sync (event + storage)
   - AJAX Add to cart + refresh XO mini cart (content/footer only)
   - Open XO cart drawer via xo-modal-trigger[xo-name="cart"]
   - Qty controls + feature tooltip mobile toggle
   - Bottle visibility failsafe (never stuck hidden)
====================================================== */

/* ---------- PROVINCE ENGINE INTERCEPT (safe) ---------- */
(function syncUltraHeroWithProvinceEngine() {
  if (!window.applyProvinceFilter || window.__ultraProvinceIntercepted) return;
  window.__ultraProvinceIntercepted = true;

  const original = window.applyProvinceFilter;

  window.applyProvinceFilter = function (...args) {
    const result = original.apply(this, args);

    const province = localStorage.getItem("ageGateProvince") || "";
    window.dispatchEvent(
      new CustomEvent("province:changed", { detail: { province } })
    );

    return result;
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  const hero = document.getElementById("NashaUltraHero");
  if (!hero) return;

  /* ---------- ELEMENTS ---------- */
  const map = window.UltraProvinceVariants || {};

  const form = document.getElementById("UltraAddForm");
  const idInput = document.getElementById("UltraVariantID");
  const provinceProp = document.getElementById("UltraProvinceProp");

  const qtyWrapper = document.querySelector(".ultra-qty");
  const qtyInput = qtyWrapper?.querySelector(".qty-input") || null;
  const minusBtn = qtyWrapper?.querySelector(".qty-minus") || null;
  const plusBtn = qtyWrapper?.querySelector(".qty-plus") || null;

  const btn = document.querySelector(".ultra-add-btn");
  // Glassy error box
  const ultraErrorBox = document.createElement("div");
  ultraErrorBox.className = "ultra-error-box";
  ultraErrorBox.style.display = "none";
  // btn?.parentNode?.appendChild(ultraErrorBox);
  const btnWrapper = btn.closest(".ultra-button-wrapper");
  btnWrapper?.appendChild(ultraErrorBox);


  const btnText = btn?.querySelector(".btn-text") || null;
  const provinceTag = document.getElementById("provinceTag");

  const bottle = document.getElementById("ultraBottle");
  const seriesEl = document.getElementById("UltraTitleSeries");
  const nameEl = document.getElementById("UltraTitleName");

  /* ---------- BOTTLE FAILSAFE (never invisible) ---------- */
  if (bottle) {
    // If CSS starts at opacity:0, this prevents a "blank hero" when JS errors.
    bottle.style.opacity = "1";
    bottle.style.visibility = "visible";
  }

  /* ------------------ SECTION RENDER API ------------------ */
  async function fetchSectionHTML(sectionId) {
    const res = await fetch(`/?sections=${encodeURIComponent(sectionId)}`, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    });
    const json = await res.json();
    return json?.[sectionId] || "";
  }

  // ✅ SAFE refresh: only the dynamic cart areas (prevents xo-modal-trigger crashes)
  async function refreshXOCartMini() {
    const html = await fetchSectionHTML("xo-cart-mini");
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, "text/html");

    const newContent = doc.querySelector(
      'xo-cart-will-change[xo-unique-id="xo-cart-mini-content"]'
    );
    const newFooter = doc.querySelector(
      'xo-cart-will-change[xo-unique-id="xo-cart-mini-drawer-footer"]'
    );

    const liveContent = document.querySelector(
      'xo-cart-will-change[xo-unique-id="xo-cart-mini-content"]'
    );
    const liveFooter = document.querySelector(
      'xo-cart-will-change[xo-unique-id="xo-cart-mini-drawer-footer"]'
    );

    if (newContent && liveContent) liveContent.innerHTML = newContent.innerHTML;
    if (newFooter && liveFooter) liveFooter.innerHTML = newFooter.innerHTML;

    console.log("[UltraHero] Cart mini refreshed (content/footer only)");
  }

  function openXOCartDrawer() {
    // ✅ Your theme uses xo-modal-trigger
    const trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
    if (trigger) {
      trigger.dispatchEvent(
        new MouseEvent("click", { bubbles: true, cancelable: true })
      );
      return;
    }

    // Fallback: modal element (if exists)
    const modal = document.querySelector('xo-modal[xo-name="cart"]');
    if (modal) {
      if (typeof modal.open === "function") return modal.open();
      if (typeof modal.show === "function") return modal.show();
      modal.setAttribute("open", "");
    }
  }

  async function addToCartAjax({ id, quantity, properties }) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id, quantity, properties })
    });

    // Shopify returns 422 with JSON error when inventory limit hit, etc.
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw err;
    }

    return res.json();
  }

  /* ------------------ TITLE PARSER ------------------ */
  (function setUltraTitle() {
    const rawTitle = hero.dataset.productTitle || "";
    if (!rawTitle || !seriesEl || !nameEl) return;

    let cleaned = rawTitle.trim();

    // Remove suffix like " [ON]" or " [MB]"
    cleaned = cleaned.replace(/\s*\[[A-Z]{2,3}\]\s*$/, "").trim();

    // Split by dash/en-dash with spaces around
    const parts = cleaned.split(/\s[-–]\s/);

    let series = "";
    let name = cleaned;

    if (parts.length > 1) {
      series = parts[0].trim();
      name = parts.slice(1).join(" - ").trim();
    }

    seriesEl.textContent = series;
    nameEl.textContent = name;
  })();

  /* ------------------ HERO ANIMATIONS (GSAP) ------------------ */
function waitForImages(container) {
  const imgs = container.querySelectorAll("img");
  return Promise.all(
    [...imgs].map((img) =>
      img.complete
        ? Promise.resolve()
        : new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve; // don't block forever
          })
    )
  );
}

async function startUltraAnimations() {
  // GSAP available?
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn("[UltraHero] GSAP/ScrollTrigger missing → skip animations");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // Wait for images so sizes/layout are correct
  await waitForImages(hero);

  // ✅ Bottle: set start state, then animate
  if (bottle) {
    // IMPORTANT: override any CSS opacity:0/1 to a known animation start
    gsap.set(bottle, { opacity: 0, y: 80, scale: 0.85, rotate: -6 });

    gsap.to(bottle, {
      opacity: 1,
      y: 0,
      scale: 1,
      rotate: 0,
      duration: 1.4,
      ease: "elastic.out(1, 0.4)"
    });
  }

  // ✅ Text reveal (only inside this hero)
  const textTargets = hero.querySelectorAll(
    ".ultra-vendor, .ultra-title, .ultra-price-box, .ultra-features, .ultra-levels, .ultra-variants, .ultra-add-btn"
  );

  if (textTargets.length) {
    gsap.from(textTargets, {
      scrollTrigger: { trigger: hero, start: "top 80%" },
      opacity: 0,
      y: 30,
      duration: 0.9,
      stagger: 0.12,
      ease: "power3.out"
    });
  }
}

startUltraAnimations();


  /* ------------------ PROVINCE → VARIANT SYNC ------------------ */
  function getActiveProvince() {
    return (localStorage.getItem("ageGateProvince") || "").trim().toUpperCase();
  }

  function applyProvinceVariant() {
    if (!form || !idInput || !btn || !btnText) return;

    const province = getActiveProvince();

    if (!province || !map[province]) {
      idInput.value = "";
      btn.disabled = true;
      btn.classList.remove("is-sold-out");
      btnText.textContent = btn.dataset.textAdd || "ADD TO CART";
      if (provinceTag) provinceTag.textContent = "";
      if (qtyWrapper) qtyWrapper.style.display = "none";
      return;
    }

    const variant = map[province];

    if (provinceProp) provinceProp.value = province;
    idInput.value = variant.id;

    if (!variant.available) {
      btn.disabled = true;
      btn.classList.add("is-sold-out");
      btnText.textContent = btn.dataset.textSold || "SOLD OUT";
      if (qtyWrapper) qtyWrapper.style.display = "none";
    } else {
      btn.disabled = false;
      btn.classList.remove("is-sold-out");
      btnText.textContent = btn.dataset.textAdd || "ADD TO CART";
      if (qtyWrapper) qtyWrapper.style.display = "";
    }

    if (provinceTag) provinceTag.textContent = `[${province}]`;
  }

  applyProvinceVariant();

  window.addEventListener("province:changed", () => applyProvinceVariant());
  window.addEventListener("storage", (e) => {
    if (e.key === "ageGateProvince") applyProvinceVariant();
  });

  /* ------------------ AJAX SUBMIT (NO REDIRECT) ------------------ */
  if (form && idInput && btn) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // ensure correct variant + availability
      applyProvinceVariant();

      const id = Number(idInput.value);
      const quantity = Math.max(1, Number(qtyInput?.value || 1));
      const province = (provinceProp?.value || "").trim();
      const variant = map[province];
      const max = variant?.max ?? null;

      // ✅ Check existing quantity in cart for this variant
      let existingQty = 0;

      try {
        const cart = await fetch("/cart.js").then(res => res.json());
        const item = cart.items.find(i => i.id === id);
        if (item) existingQty = item.quantity;
      } catch (err) {
        console.warn("[UltraHero] Could not fetch cart", err);
      }

      const totalQty = existingQty + quantity;

      if (max !== null && totalQty > max) {
        const remaining = Math.max(0, max - existingQty);
        // alert(`You can’t add ${quantity} more. Only ${remaining} item${remaining === 1 ? "" : "s"} remaining.`);
        ultraErrorBox.textContent = `You can’t add ${quantity} more.  ${remaining} item${remaining === 1 ? '' : 's'} remaining.`;
        ultraErrorBox.style.display = "block";
        ultraErrorBox.classList.add("show");

        // Auto-hide after 3.5 seconds
        setTimeout(() => {
          ultraErrorBox.classList.remove("show");
          setTimeout(() => ultraErrorBox.style.display = "none", 300);
        }, 3500);

        btn.disabled = false;
        btn.classList.remove("is-loading");
        if (btnText) btnText.textContent = btn.dataset.textAdd || "ADD TO CART";
        return;
      }



      if (!id || btn.disabled) return;

      // prevent double clicks
      btn.disabled = true;
      btn.classList.add("is-loading");
      if (btnText) btnText.textContent = "ADDING...";

      try {
        await addToCartAjax({
          id,
          quantity,
          properties: province ? { Province: province } : undefined
        });

        await refreshXOCartMini();
        openXOCartDrawer();

        // restore
        btn.classList.remove("is-loading");
        // re-apply to restore SOLD OUT state if needed
        applyProvinceVariant();
        if (!btn.disabled && btnText) btnText.textContent = btn.dataset.textAdd || "ADD TO CART";
      } catch (err) {
        btn.classList.remove("is-loading");
        applyProvinceVariant(); // restore correct state

        // Shopify inventory error message lives here most times
        const msg = err?.description || err?.message || "Could not add to cart. Please try again.";
        alert(msg);

        // keep drawer opening attempt optional (can comment out)
        openXOCartDrawer();
      }
    });
  }

  /* ------------------ QTY CONTROLS ------------------ */
  (function initQtyControls() {
    if (!qtyWrapper || !qtyInput || !minusBtn || !plusBtn) return;

    minusBtn.addEventListener("click", () => {
      const current = parseInt(qtyInput.value || "1", 10);
      qtyInput.value = Math.max(1, current - 1);
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    });

    plusBtn.addEventListener("click", () => {
      const current = parseInt(qtyInput.value || "1", 10);
      qtyInput.value = current + 1;
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    });

    qtyInput.addEventListener("change", () => {
      const n = parseInt(qtyInput.value || "1", 10);
      if (!n || n < 1) qtyInput.value = 1;
    });
  })();

  /* ------------------ FEATURE BUTTONS (MOBILE TAP) ------------------ */
  (function initFeatureButtons() {
    const buttons = document.querySelectorAll(".feature-btn");
    if (!buttons.length) return;

    buttons.forEach((b) => {
      b.addEventListener("click", (e) => {
        if (window.matchMedia("(hover: hover)").matches) return; // desktop hover
        e.stopPropagation();
        buttons.forEach((x) => x.classList.remove("is-open"));
        b.classList.toggle("is-open");
      });
    });

    document.addEventListener("click", () => {
      buttons.forEach((x) => x.classList.remove("is-open"));
    });

    window.addEventListener(
      "scroll",
      () => buttons.forEach((x) => x.classList.remove("is-open")),
      { passive: true }
    );
  })();
});
